export default "__VITE_ASSET__BhT$AJEN__"